import { render, staticRenderFns } from "./UserEmail.vue?vue&type=template&id=0359cfa8&"
import script from "./UserEmail.vue?vue&type=script&lang=js&"
export * from "./UserEmail.vue?vue&type=script&lang=js&"
import style0 from "./UserEmail.vue?vue&type=style&index=0&id=0359cfa8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports